import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";

import WP from "WP";
import api from "api";
import { setCurrentView } from "store";
import { currentLanguage, scrollWindowTo } from "helpers";
import modules from "modules";

import { getSeason } from "./SeasonRange";

import Glider from "partials/Glider/Glider";
import Container from "partials/Container";
import GridElement from "partials/GridElement";
import ErrorBoundary from "partials/ErrorBoundary";
import Footer from "partials/Footer";
import CookieNotice from "partials/CookieNotice";
import Media from "css/Media";
import { ActivitiesForm } from "./ActivitiesForm";

export class ActivitiesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activities: [],
      winter: [],
      summer: [],
      northern_lights: [],
      loading: true,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.setCurrentView(null);
    api.adventureFetcher.getAllPublic().then((resp) => {
      this.setState({ activities: resp.data }, () => this.sortBySeason());
    });

    api.pageFetcher
      .getBySlug({ slug: this.props.match.path.replace("/en/", "") })
      .then((resp) => {
        let page = resp.data[0];
        this.props.setCurrentView(page);
        this.setState({ loading: false });
      });
  }

  sortBySeason = () => {
    const { activities } = this.state;
    let winter = [];
    let summer = [];
    let northern_lights = [];
    const sortArr = (arr) =>
      arr.sort((a, b) => a.acf.activity_order - b.acf.activity_order);

    activities.map((activity) => {
      let seasonArr = getSeason(
        activity.acf.from_date,
        activity.acf.to_date,
        activity
      );
      if (seasonArr.includes("winter")) {
        winter.push(activity);
      }
      if (seasonArr.includes("summer")) {
        summer.push(activity);
      }
      if (seasonArr.includes("northern_lights")) {
        northern_lights.push(activity);
      }
      return null;
    });

    this.setState({
      winter: sortArr(winter),
      summer: sortArr(summer),
      northern_lights: sortArr(northern_lights),
    });
  };

  handleScroll(id) {
    let destination = document.getElementById(id);
    scrollWindowTo(destination, 500, "easeInOutQuad");
  }

  render() {
    const { page } = this.props;
    const { winter, summer, northern_lights, loading } = this.state;

    if (page && (winter || summer || northern_lights) && !loading) {
      return (
        <Wrapper>
          <Container grid>
            <PageDescriptionGridElement
              colStart={{ default: 1, s: 5 }}
              colEnd={{ default: 8, s: 20 }}
            >
              {currentLanguage() === "no" ? (
                <HeaderBlock>
                  <h1>Utforsk og bestill dine Svalbardopplevelser!</h1>
                  <Ingress>
                    I aktivitetskalenderen kan du søke etter opplevelser i et
                    bestemt tidsrom og legge flere aktiviteter i én samlet
                    handlekurv. Her på siden kan du også lese mer og la deg
                    inspirere av alle våre opplevelser.
                  </Ingress>
                </HeaderBlock>
              ) : (
                <HeaderBlock>
                  <h1>Explore and book your Svalbard adventures!</h1>
                  <Ingress>
                    In the activity calendar, you can search for experiences
                    within a specific time frame and add multiple activities to
                    a single shopping cart. On this page, you can also read more
                    and get inspired by all the adventures we offer.
                  </Ingress>
                </HeaderBlock>
              )}
            </PageDescriptionGridElement>
          </Container>
          <ActivitiesForm />

          <ActivityWrapper id="winter">
            <StyledGlider
              title={WP.trans.winter}
              data={winter}
              icon="snow"
              season="winter"
              filter
            />
          </ActivityWrapper>
          <ActivityWrapper id="summer">
            <StyledGlider
              title={WP.trans.summer}
              data={summer}
              icon="sun"
              season="summer"
              filter
            />
          </ActivityWrapper>
          <ActivityWrapper id="northern_lights">
            <StyledGlider
              title={WP.trans.northernLights}
              data={northern_lights}
              icon="northern_lights"
              season="northern_lights"
              filter
            />
          </ActivityWrapper>
          <Modules>
            <ErrorBoundary for="Activity Builder">
              {page
                ? page.acf.modules.map((module, i) => {
                    return (
                      <div key={i} className={"module-" + module.acf_fc_layout}>
                        {React.createElement(modules[module.acf_fc_layout], {
                          data: module,
                        })}
                      </div>
                    );
                  })
                : null}
            </ErrorBoundary>
          </Modules>
          <ErrorBoundary for="Footer">
            <Footer />
          </ErrorBoundary>
          <CookieNotice />
        </Wrapper>
      );
    } else return null;
  }
}

const mapStateToProps = (state) => ({
  page: state.currentView,
  availability: state.availability,
  adventures: state.adventures.posts[WP.lang]
    ? state.adventures.posts[WP.lang]
    : [],
});

const actions = {
  setCurrentView,
};

export default connect(mapStateToProps, actions)(ActivitiesPage);

const Wrapper = styled.section`
  scroll-behavior: smooth;
  width: 100%;
  padding-top: ${(props) => props.theme.spacing.blockM};

  ${Media.greaterThan("s")`
        padding-top: ${(props) => props.theme.spacing.blockXL};
    `}
`;

const PageDescriptionGridElement = styled(GridElement)`
  text-align: center;
  margin-bottom: ${(props) => props.theme.spacing.blockXS};

  ${Media.greaterThan("s")`
        margin-bottom: ${(props) => props.theme.spacing.blockL};
    `}

  h1 {
    ${(props) => props.theme.fonts.h2}
  }

  span {
    color: ${(props) => props.theme.colors.button};
    cursor: pointer;
    transition: opacity 0.2s ease;
    text-decoration: underline;

    &:hover,
    &:focus,
    &:visited,
    &:active {
      opacity: 0.8s;
      text-decoration: none;
    }
  }
`;

const ActivityWrapper = styled.div`
  ${Media.greaterThan("s")`
        margin-bottom: ${(props) => props.theme.spacing.blockXL};
    `}
`;

const StyledGlider = styled(Glider)`
  padding-bottom: 0;
`;

const Modules = styled.section`
  padding-bottom: ${(props) => props.theme.spacing.blockXS};

  ${Media.greaterThan("s")`
        padding-bottom: ${(props) => props.theme.spacing.blockXL};
    `}
`;

const Ingress = styled.p`
  max-width: 60ch;
`;

const HeaderBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  justify-content: space-between;
  align-items: center;
  text-wrap: balance;
`;
